import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ObjectPurposeDataTable from '../../../../components/datatables/postSecondary/ObjectPurposeDataTable';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import HeaderPortal from '../../../../portals/HeaderPortal';
import HistoryUtil from '../../../../utils/HistoryUtil';

interface ObjectPurposeListProps {
}

interface ObjectPurposeListState {
}

class ObjectPurposeListPage extends React.Component<ObjectPurposeListProps & RouteComponentProps<RouteObject>, ObjectPurposeListState> {
  constructor(props: ObjectPurposeListProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  private goToConfig = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content>
        <HeaderPortal title="Object Purpose" onBack={this.goToConfig} breadcrumbs={Breadcrumbs.objectPurposeList()} />

        <Card >
          <ObjectPurposeDataTable />
        </Card>
      </Content>
    );
  }
}

export default withRouter(ObjectPurposeListPage);
